<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      id="sendingLoadingScreen"
      centered
      :title="title">
    <mutable-icon
        :icons="[
                        {status:0,module:'spinner',variant:'primary', text:'Envoie en Cours...'},
                        {status:1,icon:'check-circle', scale:'3', variant:'success', text:'Envoie terminé avec succès'},
                        {status:2,icon:'exclamation-circle', scale:'3', variant:'danger', text:'Échec de l\'envoie'},
                        ]"
        :current="sendingStatus"
    />
  </b-modal>
</template>

<script>
import MutableIcon from "@/components/mutableIcon";

export default {
  name      : "modalSendStatus",
  components: {MutableIcon},
  props     : ['title', 'sendingStatus']
}
</script>

<style scoped>

</style>